import React, { useState, useEffect } from "react";

// @mui material components
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Tooltip from "@mui/material/Tooltip";

// Timeline context
import { useTimeline } from "examples/Timeline/context";

// Custom styles for the TimelineItem
import { timelineItem, timelineItemIcon } from "examples/Timeline/TimelineItem/styles";
// Data
import { MANUFACTURER_SERVICES } from "utils/data";

const EditList = ({ store, register, setValue }) => {
  const isDark = useTimeline();
  const [selectedTags, setSelectedTags] = useState([]);
  useEffect(() => {
    let services = store?.metadata?.services || [];
    setSelectedTags(services);
    register("services");
    setValue("services", services);
    MANUFACTURER_SERVICES.map((s) => {
      let value = "";
      if (store?.metadata?.servicesDescription && store.metadata.servicesDescription[s.value]) {
        value = store.metadata.servicesDescription[s.value];
      }
      setValue(`servicesDescription[${s.value}]`, value);
    });
  }, [store]);

  const handleChangeBadge = (value) => {
    if (selectedTags.includes(value)) {
      const newTags = selectedTags.filter((x) => x != value);
      setSelectedTags(newTags);
      setValue("services", newTags);
    } else {
      setSelectedTags([...selectedTags, value]);
      setValue("services", [...selectedTags, value]);
    }
  };

  return (
    <div>
      {MANUFACTURER_SERVICES.map((s, index) => (
        <SuiBox
          position="relative"
          sx={(theme) =>
            timelineItem(theme, { lastItem: index == MANUFACTURER_SERVICES.length - 1 })
          }
        >
          <SuiBox
            bgColor={isDark ? "dark" : "white"}
            width="1.625rem"
            height="1.625rem"
            borderRadius="50%"
            position="absolute"
            top="3.25%"
            left="2px"
            zIndex={2}
          >
            <Icon sx={(theme) => timelineItemIcon(theme, { color: s.color })}>{s.icon}</Icon>
          </SuiBox>
          <SuiBox ml={5.75} pt={0.7} lineHeight={0} maxWidth="30rem">
            <SuiTypography
              variant="button"
              fontWeight="medium"
              fontSize="large"
              color={isDark ? "white" : "dark"}
            >
              {s.label}
            </SuiTypography>
            <SuiBox mt={2} mb={1.5}>
              <SuiInput
                placeholder="Describe your services"
                minRows={4}
                maxRows={4}
                multiline={true}
                fullWidth={true}
                {...register(`servicesDescription[${s.value}]`)}
              />
            </SuiBox>

            <SuiBox display="flex" pb={index == MANUFACTURER_SERVICES.length - 1 ? 1 : 2}>
              <SuiTypography
                variant="button"
                fontWeight="medium"
                fontSize="small"
                mr={1}
                color={isDark ? "white" : "dark"}
              >
                Services:
              </SuiTypography>
              <div className="flex flex-wrap">
                {s?.children.map((badge, key) => {
                  const badgeKey = `badge-${key}`;

                  return (
                    <SuiBox key={badgeKey} mr={0.5} mb={1}>
                      {selectedTags.includes(badge.value) ? (
                        <SuiBadge
                          className="hover:cursor-pointer"
                          color={s.color}
                          size="xs"
                          badgeContent={capitalCase(badge.label, {
                            stripRegexp: /[^A-Z0-9\'\&\/\-_]/gi,
                          })}
                          onClick={() => handleChangeBadge(badge.value)}
                          container
                        />
                      ) : (
                        <div className="hover:cursor-pointer outline-1 border underline whitespace-nowrap">
                          <Tooltip title={"Click to select"} placement="top">
                            <SuiTypography
                              variant="button"
                              fontWeight="medium"
                              fontSize="small"
                              color={isDark ? "white" : "dark"}
                              onClick={() => handleChangeBadge(badge.value)}
                            >
                              {badge.label}
                            </SuiTypography>
                          </Tooltip>
                        </div>
                      )}
                    </SuiBox>
                  );
                })}
              </div>
            </SuiBox>
          </SuiBox>
        </SuiBox>
      ))}
    </div>
  );
};

export default EditList;
